import { size } from 'lodash/fp';
import { Stack } from '@optimus-web/core';
import { DefaultErrorBoundary } from '@mews-commander/ui';
import { isDefiniteState } from '@mews-commander/types';
import { ServiceOrderState } from '@mews-commander/legacy-data-structures';
import NewProductOrders from './NewProductOrders';
import ItemsNightsTable from './ItemsNightsTable';
import AdditionalExpenses from './AdditionalExpenses';
import AddProductFormCard from './AddProductFormCard';

const ADD_PRODUCT_FORM_INITIAL_VALUES = {
    count: 1,
};

const SingleReservationCheckedComponents = ({ checkedReservation, refetchGroup }: $TSFixMe) => {
    const { serviceId, state, id, groupId, customerId } = checkedReservation;
    // @ts-expect-error $TSFixMeError: Object is possibly 'undefined'.
    const canReservationAcceptNewDeposit = isDefiniteState(ServiceOrderState.getByValue(state).name);
    const commonTableProps = { reservationId: id, accountId: customerId, groupId, serviceId };
    return (
        <>
            <ItemsNightsTable {...commonTableProps} />
            <AdditionalExpenses
                canReservationAcceptNewDeposit={canReservationAcceptNewDeposit}
                refetchGroup={refetchGroup}
                {...commonTableProps}
            />
            {/* @ts-expect-error $TSFixMeError: Property 'products' is missing in type '{ reservationId: any; accountId: any; groupId: any; serviceId: any; refetchGroup... */}
            <NewProductOrders refetchGroup={refetchGroup} {...commonTableProps} />
        </>
    );
};

const ItemsTab = ({
    checkedReservation,
    refetchGroup,
    reservationIds,
    serviceProducts,
    serviceId,
    scope,
}: $TSFixMe) => (
    <DefaultErrorBoundary>
        <Stack spacing="200" vertical>
            {size(reservationIds) === 1 ? (
                <SingleReservationCheckedComponents
                    checkedReservation={checkedReservation}
                    refetchGroup={refetchGroup}
                />
            ) : null}
            <AddProductFormCard
                form={`add-product-form-${scope}`}
                scope={scope}
                refetchGroup={refetchGroup}
                reservationIds={reservationIds}
                products={serviceProducts}
                serviceId={serviceId}
                initialValues={ADD_PRODUCT_FORM_INITIAL_VALUES}
            />
        </Stack>
    </DefaultErrorBoundary>
);

export default ItemsTab;
